import React, { FC, useEffect } from 'react'
import CrossIcon from '../icons/cross.svg'

const TOAST_MS = 10000

interface IProps {
  title: string
  text: React.ReactNode
  onUndo?: () => void
  onClose: () => void
}

const Toast: FC<IProps> = ({ title, text, onUndo, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, TOAST_MS)
    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div className="toast" role="status" data-testid="toast">
      <div className="toast_body">
        <div className="toast_title">{title}</div>
        <div className="toast_text">{text}</div>
      </div>
      {onUndo && (
        <button
          type="button"
          className="toast_action clear-button"
          onClick={onUndo}
          data-testid="toast-undo"
        >
          Undo
        </button>
      )}
      <button
        type="button"
        className="toast_close clear-button"
        onClick={onClose}
        aria-label="Close"
      >
        <CrossIcon />
      </button>
    </div>
  )
}

export default Toast
